import styled from "styled-components";

export const LgpdContainer = styled.div`
  p {
    font: 300 1.4rem ${({ theme }) => theme.fonts.mainFont} !important;
    letter-spacing: 0.5px;
  }
`;
